import React, { Fragment } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import {
  Box,
  Grid,
  Card,
  CardContent,
  colors,
  Icon,
  Typography,
  Button,
  makeStyles
} from '@material-ui/core';

import { BsFillPersonFill } from "react-icons/bs";
import { MdGroup } from "react-icons/md";
import { MdMessage } from "react-icons/md";
import { Activity } from 'react-feather';
import { MdEngineering } from "react-icons/md";
import { AiFillSetting } from "react-icons/ai";
import { AiFillTool } from "react-icons/ai";
import { AiOutlineAreaChart } from "react-icons/ai";
import { BsHddNetworkFill } from "react-icons/bs";
import {BsCurrencyExchange} from "react-icons/bs";

const items = [
  {
    href: '/adm/company',
    icon: AiOutlineAreaChart,
    title: 'Operação',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/adm/users',
    icon: BsFillPersonFill,
    title: 'Usuário',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/adm/groups',
    icon: MdGroup,
    title: 'Equipe',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/adm/mailing',
    icon: MdMessage,
    title: 'Notificação',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/adm/equipments',
    icon: BsHddNetworkFill,
    title: 'Equipamento',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/sup/main',
    icon: AiFillTool,
    title: 'Assistência Técnica',
    color: colors.orange[400],
    profile: 'ADM'
  },
  {
    href: '/adm/company',
    icon: AiOutlineAreaChart,
    title: 'Operação',
    color: colors.blue[400],
    profile: 'ENG'
  },
  {
    href: '/adm/users',
    icon: BsFillPersonFill,
    title: 'Usuário',
    color: colors.blue[400],
    profile: 'ENG'
  },
  {
    href: '/adm/groups',
    icon: MdGroup,
    title: 'Equipe',
    color: colors.blue[400],
    profile: 'ENG'
  },
  {
    href: '/adm/mailing',
    icon: MdMessage,
    title: 'Notificação',
    color: colors.blue[400],
    profile: 'ENG'
  },
  {
    href: '/adm/equipments',
    icon: BsHddNetworkFill,
    title: 'Equipamento',
    color: colors.blue[400],
    profile: 'ENG'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/fin/main',
    icon: BsCurrencyExchange,
    title: 'Financeiro',
    color: colors.green[600],
    profile: 'ENG'
  },
  {
    href: '/sup/main',
    icon: AiFillTool,
    title: 'Assistência Técnica',
    color: colors.orange[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/main',
    icon: AiFillSetting,
    title: 'Configuração',
    color: colors.indigo[400],
    profile: 'ENG'
  },
];

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    width: 120,
    height: 120
  },
  grid: {
    marginTop: 10
  },
  card: {
    height: 200,
    minWidth: 200
  },
  button: {
    fontWeight: theme.typography.fontWeightMedium,
    textTransform: 'none',
    width: '100%'
  }
}));

const Results = ({ className }) => {

  const classes = useStyles();

  return (
    <Fragment>
      <Box>
        <Grid container
          className={classes.grid}
          spacing={2}
          direction="row"
          justifyContent={(screen.width <= 480) ? "center" : "flex-start"}
        >

          {items.map((value) => (

            <Grid item key={value.href} hidden={localStorage.getItem('profile') != value.profile}  >

              <Button
                className={classes.button}
                component={RouterLink}
                to={value.href}
              >

                <Card className={classes.card}>

                  <CardContent>

                    <Box alignItems="center"
                      display="flex"
                      flexDirection="column"
                    >

                      {<Icon className={classes.avatar} component={value.icon} style={{ color: value.color }} ></Icon>}

                      <Typography align="center"
                        color="primary"
                        gutterBottom
                        variant="h4"
                      >
                        {value.title}
                      </Typography>
                    </Box>

                  </CardContent>

                </Card>

              </Button>

            </Grid>

          ))}


        </Grid>

      </Box>

    </Fragment >
  );
};

export default Results;